import { createContext, useContext } from "react";

type OnErrorSignature = (response: Response, error?: any) => Promise<boolean>;
const ErrorHandlerContext = createContext<OnErrorSignature | null>(null);
const ErrorHandlerProvider = ErrorHandlerContext.Provider;
const ErrorHandlerConsumer = ErrorHandlerContext.Consumer;
const useErrorHandlerContext = () => useContext(ErrorHandlerContext);
export default  useErrorHandlerContext;
export { ErrorHandlerContext, ErrorHandlerConsumer, ErrorHandlerProvider};

export type { OnErrorSignature };